module.exports = __webpack_public_path__ + "img/CODcr.a0609906.png";